import { Builder } from '@builder.io/react'
import React from 'react'

import BackgroundFiller, { BackgroundFillerProps, IBackgroundFillerProps } from '../../bg-filler'
import CreatePlan, { CreatePlanProps, ICreatePlan } from './create-plan'
import DoctorSay, { DoctorSayProps, IDoctorSay } from './doctor-say'
import RecipeHero, { RecipeHeroProps, IRecipeHeroProps } from './hero-recipe'
import RecipeIngredient, { IRecipeIngredientProps, RecipeIngredientProps } from './ingredient'
import ReadyForDD, { ReadyForDDProps, IReadyForDD } from './ready-for-dd'
import RecipeListerWrapper, { RecipeListerWrapperProps, IRecipeListerProps } from './recipe-lister'

import './recipe.css'

interface Props {
  recipeHero: IRecipeHeroProps
  recipeIngredient: IRecipeIngredientProps
  backgroundFiller: IBackgroundFillerProps
  doctorSayProps: IDoctorSay
  backgroundFillerTwo: IBackgroundFillerProps
  createPlanProps: ICreatePlan
  recipeListerWrapperProps: IRecipeListerProps
  backgroundFillerThree: IBackgroundFillerProps
  readyForDDProps: IReadyForDD
}

const CustomRecipeTemplate = ({
  recipeHero,
  recipeIngredient,
  backgroundFiller,
  doctorSayProps,
  backgroundFillerTwo,
  createPlanProps,
  recipeListerWrapperProps,
  backgroundFillerThree,
  readyForDDProps
}: Props) => {
  // console.log("HERE IS THE DATA THAT YOU WANT", recipeHero);
  recipeHero = recipeHero || {}
  recipeIngredient = recipeIngredient || {}
  backgroundFiller = backgroundFiller || {}
  doctorSayProps = doctorSayProps || {}
  backgroundFillerTwo = backgroundFillerTwo || {}
  createPlanProps = createPlanProps || {}
  recipeListerWrapperProps = recipeListerWrapperProps || {}
  backgroundFillerThree = backgroundFillerThree || {}
  readyForDDProps = readyForDDProps || {}
  return (
    <div className="overflow-clip">
      <RecipeHero
        backgroundColor={recipeHero.backgroundColor}
        backgroundImage={recipeHero.backgroundImage}
        heroImage={recipeHero.heroImage}
        recipeSummary={recipeHero.recipeSummary}
        recipeTitle={recipeHero.recipeTitle}
        recipeSummaryColor={recipeHero.recipeSummaryColor}
        builderHeroImage={recipeHero.builderHeroImage}
        cloudinaryHeroImage={recipeHero.cloudinaryHeroImage}
        heroImagePosition={recipeHero.heroImagePosition}
        recipeTitleColor={recipeHero.recipeTitleColor}
        recipeAdultOnly={recipeHero?.adultOnly}
      />
      <RecipeIngredient
        backgroundColor={recipeIngredient.backgroundColor}
        dogImage={recipeIngredient.dogImage}
        dogImageBackgroundColor={recipeIngredient.dogImageBackgroundColor}
        mainDescription={recipeIngredient.mainDescription}
        mainDescriptionColor={recipeIngredient.mainDescriptionColor}
        subDescription={recipeIngredient.subDescription}
        subDescriptionColor={recipeIngredient.subDescriptionColor}
        ingredientItems={recipeIngredient.ingredientItems}
        analyticalThings={recipeIngredient.analyticalThings}
        recipeIngredientImg={recipeIngredient.recipeIngredientImg}
        CTATitle={recipeIngredient.CTATitle}
        CTAButton={recipeIngredient.CTAButton}
      />
      <BackgroundFiller
        backgroundColor={backgroundFiller.backgroundColor}
        complimentImage={backgroundFiller.complimentImage}
        enableComplimentImage={backgroundFiller.enableComplimentImage}
        fillerImage={backgroundFiller.fillerImage}
        fillerImagePos={backgroundFiller.fillerImagePos}
        fillerImagePosAmount={backgroundFiller.fillerImagePosAmount}
        heightSize={backgroundFiller.heightSize}
        complimentImageFill={backgroundFiller.complimentImageFill}
      />
      {doctorSayProps.showDoctorSay && (
        <DoctorSay
          backgroundColor={doctorSayProps.backgroundColor}
          mainText={doctorSayProps.mainText}
          mainTextColor={doctorSayProps.mainTextColor}
          subText={doctorSayProps.subText}
          subTextColor={doctorSayProps.subTextColor}
          doctorImg={doctorSayProps.doctorImg}
          doctorImgBGColor={doctorSayProps.doctorImgBGColor}
        />
      )}
      <BackgroundFiller
        backgroundColor={backgroundFillerTwo.backgroundColor}
        complimentImage={backgroundFillerTwo.complimentImage}
        enableComplimentImage={backgroundFillerTwo.enableComplimentImage}
        fillerImage={backgroundFillerTwo.fillerImage}
        fillerImagePos={backgroundFillerTwo.fillerImagePos}
        fillerImagePosAmount={backgroundFillerTwo.fillerImagePosAmount}
        heightSize={backgroundFillerTwo.heightSize}
        complimentImageFill={backgroundFillerTwo.complimentImageFill}
      />
      {createPlanProps.showCreatePlan && (
        <CreatePlan
          backgroundColor={createPlanProps.backgroundColor}
          createPlanImage={createPlanProps.createPlanImage}
          createPlanImageBG={createPlanProps.createPlanImageBG}
          createPlanTitle={createPlanProps.createPlanTitle}
          createPlanTitleColor={createPlanProps.createPlanTitleColor}
          createPlanSummary={createPlanProps.createPlanSummary}
          createPlanSummaryColor={createPlanProps.createPlanSummaryColor}
          // createPlanArrow={createPlanProps.createPlanArrow}
          foodCharacteristics={createPlanProps.foodCharacteristics}
          buttonProps={createPlanProps.buttonProps}
        />
      )}
      <RecipeListerWrapper
        articleDescriptionTextColor={recipeListerWrapperProps.articleDescriptionTextColor}
        articleItemBackgroundColor={recipeListerWrapperProps.articleItemBackgroundColor}
        articleTitleTextColor={recipeListerWrapperProps.articleTitleTextColor}
        autoplayTime={recipeListerWrapperProps.autoplayTime}
        backgroundColor={recipeListerWrapperProps.backgroundColor}
        maxNumberOfFeature={recipeListerWrapperProps.maxNumberOfFeature}
        maxNumberToList={recipeListerWrapperProps.maxNumberToList}
        recipeBulletPoint={recipeListerWrapperProps.recipeBulletPoint}
        listerTitle={recipeListerWrapperProps.listerTitle}
        listerTitleColor={recipeListerWrapperProps.listerTitleColor}
        listerFirstBGColor={recipeListerWrapperProps.listerFirstBGColor}
        listerBgColor={recipeListerWrapperProps.listerBgColor}
        buttonProps={recipeListerWrapperProps.buttonProps}
      />
      <BackgroundFiller
        backgroundColor={backgroundFillerThree.backgroundColor}
        complimentImage={backgroundFillerThree.complimentImage}
        enableComplimentImage={backgroundFillerThree.enableComplimentImage}
        fillerImage={backgroundFillerThree.fillerImage}
        fillerImagePos={backgroundFillerThree.fillerImagePos}
        fillerImagePosAmount={backgroundFillerThree.fillerImagePosAmount}
        heightSize={backgroundFillerThree.heightSize}
        complimentImageFill={backgroundFillerThree.complimentImageFill}
      />
      <ReadyForDD
        backgroundColor={readyForDDProps.backgroundColor}
        buttonProps={readyForDDProps.buttonProps}
        question={readyForDDProps.question}
        questionTextColor={readyForDDProps.questionTextColor}
      />
    </div>
  )
}

export default CustomRecipeTemplate

Builder.registerComponent(CustomRecipeTemplate, {
  name: 'CustomRecipeTemplate',
  inputs: [
    {
      ...RecipeHeroProps
    },
    {
      ...RecipeIngredientProps
    },
    {
      name: 'backgroundFiller',
      type: 'object',
      subFields: [...BackgroundFillerProps.inputs]
    },
    {
      ...DoctorSayProps
    },
    {
      name: 'backgroundFillerTwo',
      type: 'object',
      subFields: [...BackgroundFillerProps.inputs]
    },
    {
      ...CreatePlanProps
    },
    {
      ...RecipeListerWrapperProps
    },
    {
      name: 'backgroundFillerThree',
      type: 'object',
      subFields: [...BackgroundFillerProps.inputs]
    },
    {
      ...ReadyForDDProps
    }
  ]
})
